<template>
  <v-app>
    <Navbar :voltar="true" app />
    <Sidebar />
    <v-main>
      <v-container class="container" fluid>
        <Breadcrumbs :items="items" />
        <v-card class="mx-auto" max-width="1000" elevation="1">
          <v-toolbar color="#343F53">
            <v-card-title
              class="headline font-weight-bold d-flex align-center justify-space-between px-4 w-100"
            >
              <span style="color: white"
                >GERENCIAMENTO DESPEDIDA ({{ despedida.id }})</span
              >
            </v-card-title>
          </v-toolbar>

          <v-card-text>
            <v-card elevation="0">
              <div class="d-flex justify-end" v-if="!isOnlyModerador">
                <v-btn
                  color="#343F53"
                  @click="sincronizar()"
                  title="Sincronizar com o sistema iVertex"
                  :disabled="!falecido.id_iVertex || falecido.id_iVertex == 0"
                >
                  <v-icon color="white" class="mr-2">mdi-refresh</v-icon>
                  Sincronizar iVertex
                </v-btn>
              </div>
              <v-card-text>
                <v-form v-model="valid">
                  <div class="section-header">
                    <h3 class="section-title">Informações do Falecido</h3>
                    <v-divider class="mb-4"></v-divider>
                  </div>
                  <v-row>
                    <v-col cols="12" v-if="!isOnlyModerador">
                      <v-text-field
                        v-model="falecido.nome_social"
                        :counter="100"
                        label="Apelido"
                        hide-details
                        required
                        class="custom-text-field"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="falecido.nome"
                        :counter="100"
                        label="Nome"
                        readonly
                        hide-details
                        required
                        class="custom-text-field"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="falecido.data_nascimento"
                        label="Data de Nascimento"
                        readonly
                        hide-details
                        required
                        type="date"
                        class="custom-text-field"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="falecido.data_falecimento"
                        label="Data de Falecimento"
                        hide-details
                        readonly
                        type="date"
                        class="custom-text-field"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" class="pb-0">
                      <v-radio-group
                        v-model="falecido.sexo"
                        inline
                        color="blue"
                        readonly
                      >
                        <v-radio label="Masculino" value="Masculino"></v-radio>
                        <v-radio label="Feminino" value="Feminino"></v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>
                  <div class="section-header pt-10">
                    <h3 class="section-title">Informações do Cemitério</h3>
                    <v-divider class="mb-4"></v-divider>
                  </div>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="despedida.local_sepultamento"
                        :counter="100"
                        label="Cemitério sepultamento"
                        hide-details
                        required
                        :disabled="isOnlyModerador"
                        class="custom-text-field"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="despedida.localizacao_sepultado"
                        :counter="100"
                        label="Jazigo sepultamento"
                        hide-details
                        required
                        class="custom-text-field"
                        :disabled="isOnlyModerador"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="despedida.data_sepultamento"
                        label="Data Sepultamento"
                        :disabled="isOnlyModerador"
                        hide-details
                        required
                        type="datetime-local"
                        class="custom-text-field"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <div class="section-header pt-10">
                    <h3 class="section-title">Informações do Velório</h3>
                    <v-divider class="mb-4"></v-divider>
                  </div>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="despedida.local_velorio"
                        :counter="100"
                        :disabled="isOnlyModerador"
                        label="Local Velório"
                        hide-details
                        required
                        class="custom-text-field"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="despedida.data_velorio"
                        label="Data Velório"
                        :disabled="isOnlyModerador"
                        hide-details
                        required
                        type="datetime-local"
                        class="custom-text-field"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <div class="section-header pt-10">
                    <h3 class="section-title">Informações da Despedida</h3>
                    <v-divider class="mb-4"></v-divider>
                  </div>
                  <v-col cols="12">
                    <v-textarea
                      v-model="despedida.obituario"
                      label="Biografia"
                      outlined
                      counter="1000"
                      required
                      maxlength="1000"
                      rows="5"
                      placeholder="Escreva uma breve biografia..."
                      no-resize
                    ></v-textarea>
                  </v-col>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-select
                        v-model="despedida.tipo"
                        label="Visualização do Perfil"
                        :items="['Publica', 'Privada']"
                        required
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-switch
                        v-model="despedida.com_moderacao"
                        label="Comentários com moderação"
                        required
                        inset
                        color="green"
                      ></v-switch>
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <div class="user">
                        <v-img
                          :src="
                            imagem_falecido_novo || getFotoPerfilUrl(despedida.nome_arquivo_foto_perfil) ||
                            getFotoPadrao(despedida)
                          "
                          class="profile-img"
                          @click="$refs.fileInput.click()"
                        />
                        <v-icon
                          class="icon primary white--text"
                          @click="$refs.fileInput.click()"
                          >mdi-upload</v-icon
                        >
                        <input
                          ref="fileInput"
                          type="file"
                          accept="image/*"
                          style="display: none"
                          @change="onFileSelect"
                        />
                      </div>

                      <v-dialog v-model="dialog" width="500">
                        <v-card>
                          <v-card-text>
                            <VueCropper
                              v-show="selectedFile"
                              ref="cropper"
                              :src="selectedFile"
                              :viewMode="1"
                              :zoomable="true"
                              :scalable="true"
                              :autoCropArea="1"
                              alt="Imagem selecionada"
                            />
                          </v-card-text>
                          <v-card-actions>
                            <v-btn outlined class="primary" @click="saveImage"
                              >Recortar</v-btn
                            >
                            <v-btn text @click="dialog = false">Cancelar</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-col>
                    <v-col cols="12">
                      <v-card elevation="0">
                        <v-radio-group v-model="despedida.foto_fundo" column>
                          <v-row dense>
                            <v-col
                              v-for="(image, index) in images"
                              :key="index"
                              cols="12"
                              md="6"
                            >
                              <v-card>
                                <v-radio :value="image.id"></v-radio>
                                <img
                                  :src="
                                    require(`@/assets/pack-banners/${image.id}.jpg`)
                                  "
                                  width="400px"
                                  alt="Imagem de banner"
                                />
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-radio-group>
                      </v-card>
                    </v-col>
                    <div class="text-center pa-4">
                      <v-btn
                        :disabled="loadingDespedida"
                        :loading="loadingDespedida"
                        variant="outlined"
                        color="#343F53"
                        @click="updateDespedida()"
                      >
                        Atualizar
                      </v-btn>
                    </div>
                  </v-row>
                </v-form>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>
      </v-container>
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import { useToast } from "vue-toastification";
import Sidebar from "@/components/restrito/Sidebar.vue";
import Navbar from "@/components/restrito/Navbar.vue";
const toast = useToast();
import Footer from "./Footer.vue";
import { http } from "@/services/config";
import authHeader from "@/services/auth-header";
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import Breadcrumbs from "@/components/utils/Breadcrumbs.vue";
export default {
  name: "EditarDespedida",
  components: {
    Navbar,
    Sidebar,
    Footer,
    VueCropper,
    Breadcrumbs,
  },
  data() {
    return {
      items: [
        {
          title: "Início",
          disabled: false,
          href: "/admin/despedidas",
        },
        {
          title: "Editar Despedida",
          disabled: true,
        },
      ],
      dialog: false,
      selectedFile: null,
      mime_type: "",
      unidades: [
        "Central de Velórios",
        "Parque das Flores",
        "Memorial Parque Maceió",
        "Cemitério Previda",
        "Parque do Agreste",
      ],
      capelasPorUnidade: {
        "Memorial Parque Maceió": ["01", "02", "03", "04", "05", "06", "07"],
        "Central de Velórios": ["01", "02", "03", "04"],
        "Parque das Flores": ["01", "02", "03", "04"],
        "Cemitério Previda": ["01", "02", "03", "04"],
        "Parque do Agreste": ["01", "02", "03", "04"],
      },
      loadingFalecido: false,
      loadingModerador: false,
      loadingDespedida: false,
      vazio: "",
      id: null,
      tab: null,
      selectedImage: null,
      images: [
        { id: "1" },
        { id: "2" },
        { id: "3" },
        { id: "4" },
        { id: "5" },
        { id: "6" },
        { id: "7" },
        { id: "8" },
        { id: "9" },
        { id: "10" },
        { id: "11" },
        { id: "12" },
      ],
      falecido: {},
      moderador: {
        nome: "",
        telefone: "",
        email: "",
        password: "",
        moderador_cliente: "Ainda não",
        parentesco_falecido: "Não informado",
      },
      despedida: {},
      roles: [],
      imagem_falecido_novo: null,
      imagem_falecido_file: null,
    };
  },
  mounted() {
    this.setRolesFromSession();
    this.id = this.$route.params.id;
    this.despedidas();
  },
  computed: {
    capelasDisponiveis() {
      return this.capelasPorUnidade[this.despedida.capela.unidade] || [];
    },
    defaultProfilePicture() {
      if (this.falecido?.sexo?.toLowerCase() === "feminino") {
        return require("@/assets/feminino.png");
      }
      return require("@/assets/masculino.png");
    },
    isOnlyModerador() {
      return (
        this.roles.includes("ROLE_MODERADOR") &&
        !this.roles.includes("ROLE_ADMIN") &&
        !this.roles.includes("ROLE_COLABORADOR")
      );
    },
  },
  methods: {
    getFotoPadrao(item) {
      const sexo = item?.pessoa_falecida?.sexo || "Masculino";
      return sexo === "Feminino"
        ? require("@/assets/feminino.png")
        : require("@/assets/masculino.png");
    },
    setRolesFromSession() {
      const user = JSON.parse(sessionStorage.getItem("user"));
      this.roles = user?.roles || [];
    },
    formatDateTime(value) {
      if (!value) return null;
      const date = new Date(value);
      const pad = (n) => n.toString().padStart(2, "0");

      const year = date.getFullYear();
      const month = pad(date.getMonth() + 1);
      const day = pad(date.getDate());
      const hours = pad(date.getHours());
      const minutes = pad(date.getMinutes());
      const seconds = "00"; // fixo

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    onFileSelect(e) {
      const file = e.target.files[0];
      if (!file) return;
      this.mime_type = file.type;
      const reader = new FileReader();
      reader.onload = (event) => {
        this.selectedFile = event.target.result;
        this.dialog = true;
      };
      reader.readAsDataURL(file);
    },
    saveImage() {
      const canvas = this.$refs.cropper.getCroppedCanvas();
      if (!canvas) return;

      canvas.toBlob((blob) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          this.imagem_falecido_novo = reader.result;
          this.imagem_falecido_file = blob;
          this.dialog = false;
        };
        reader.readAsDataURL(blob);
      }, this.mime_type);
    },
    finalizar() {
      this.$router.push("/admin/despedidas");
    },
    formatDate(date) {
      if (!date) return "";
      const isoDate = date.split("T")[0];
      const [year, month, day] = isoDate.split("-");
      return `${day}/${month}/${year}`;
    },
    despedidas() {
      http
        .get(`cliente/despedida/${this.id}`, {
          headers: authHeader(),
        })
        .then((response) => {
          this.despedida = response.data;
          this.falecido = this.despedida.pessoa_falecida;
          this.moderador = this.despedida.pessoa_moderador;
        })
        .catch((error) => {
          console.error("Erro ao consultar:", error);
        });
    },

    async updateFalecido() {
      this.loadingFalecido = true;
      try {
        const response = await http.post(
          "cliente/update-pessoa-falecida",
          {
            id: this.falecido.id,
            nome: this.falecido.nome,
            nome_social: this.falecido.nome_social,
            data_nascimento: this.falecido.data_nascimento,
            data_falecimento: this.falecido.data_falecimento,
            cidade: this.falecido.cidade,
            estado: this.falecido.estado,
            pais: this.falecido.pais,
          },
          {
            headers: authHeader(),
          }
        );
        toast.success("Atualização finalizada com sucesso!");
        this.$router.push("/admin/despedidas");
        if (!response) {
          console.log(response);
        }
      } catch (error) {
        console.error("Erro ao atualizar falecido:", error);
        throw error;
      }
      this.loadingFalecido = false;
    },

    async updateModerador() {
      this.loadingModerador = true;
      try {
        const response = await http.post(
          "cliente/update-pessoa-moderador",
          {
            pessoa: {
              id: this.moderador.id,
              nome: this.moderador.nome,
              telefone: this.moderador.telefone,
              moderador_cliente: this.moderador.cliente,
              parentesco_falecido: this.moderador.parentesco,
              tipo_parentesco: this.moderador.tipoParentesco,
            },
          },
          {
            headers: authHeader(),
          }
        );
        toast.success("Atualização finalizada com sucesso!");
        this.$router.push("/admin/despedidas");
        if (!response) {
          console.log(response);
        }
      } catch (error) {
        console.error("Erro ao atualizar moderador:", error);
        throw error;
      }
      this.loadingModerador = false;
    },

    async updateNomeSocial() {
      try {
        const response = await http.put(
          `cliente/update-falecido-nome-social/${this.falecido.id}`,
          this.falecido.nome_social,
          {
            headers: {
              ...authHeader(),
              "Content-Type": "text/plain",
            },
          }
        );

        console.log(response.data);
      } catch (error) {
        console.error("Erro ao atualizar falecido:", error);
        throw error;
      }
    },

    async sincronizar() {
      this.loadingDespedida = true;

      try {
        const response = await http.patch(
          `cliente/update-falecido-sincronizar-ivertex/${this.falecido.id}`,
          null,
          {
            headers: authHeader(),
          }
        );

        toast.success("Atualização finalizada com sucesso!");
        this.despedidas();

        if (!response) {
          console.log(response);
        }
      } catch (error) {
        console.error("Erro ao atualizar despedida:", error);

        const msg =
          error.response?.data ||
          error.response?.data?.message ||
          "Erro ao sincronizar despedida.";

        toast.error(msg);
      }

      this.loadingDespedida = false;
    },

    async updateDespedida() {
      this.loadingDespedida = true;

      if (!this.isOnlyModerador) {
        await this.updateNomeSocial();
      }

      this.despedida.data_velorio = this.formatDateTime(
        this.despedida.data_velorio
      );
      this.despedida.data_sepultamento = this.formatDateTime(
        this.despedida.data_sepultamento
      );
      const rota = this.isOnlyModerador
        ? "cliente/update-despedida-moderador"
        : "cliente/update-despedida";

      try {
        let response;

        if (this.imagem_falecido_file) {
          const despedidaPayload = {
            id: this.despedida.id,
            funeraria: this.despedida.funeraria,
            data_velorio: this.despedida.data_velorio,
            local_velorio: this.despedida.local_velorio,
            codigo_jazigo: this.despedida.codigo_jazigo,
            data_sepultamento: this.despedida.data_sepultamento,
            local_sepultamento: this.despedida.local_sepultamento,
            localizacao_sepultado: this.despedida.localizacao_sepultado,
            foto_fundo: this.despedida.foto_fundo,
            contrato_plano: this.despedida.contrato_plano,
            contrato_jazigo: this.despedida.contrato_jazigo,
            dataCreate: this.despedida.dataCreate,
            data_update: this.despedida.data_update,
            user_create: this.despedida.user_create,
            user_update: this.despedida.user_update,
            status_memoria: this.despedida.status_memoria,
            tipo: this.despedida.tipo,
            com_moderacao: this.despedida.com_moderacao,
            transmissao: this.despedida.transmissao,
            codigo_transmissao: this.despedida.codigo_transmissao,
            obituario: this.despedida.obituario,
            publicacao: this.despedida.publicacao,
          };

          const formData = new FormData();
          formData.append("despedida", JSON.stringify(despedidaPayload));
          formData.append("imagemFalecido", this.imagem_falecido_file);

          response = await http.post(rota, formData, {
            headers: authHeader(),
          });
        } else {
          response = await http.post(
            rota,
            {
              id: this.despedida.id,
              foto_perfil: null,
              nome_arquivo_foto_perfil: this.despedida.nome_arquivo_foto_perfil,
              funeraria: this.despedida.funeraria,
              data_velorio: this.despedida.data_velorio,
              local_velorio: this.despedida.local_velorio,
              codigo_jazigo: this.despedida.codigo_jazigo,
              data_sepultamento: this.despedida.data_sepultamento,
              local_sepultamento: this.despedida.local_sepultamento,
              localizacao_sepultado: this.despedida.localizacao_sepultado,
              foto_fundo: this.despedida.foto_fundo,
              contrato_plano: this.despedida.contrato_plano,
              contrato_jazigo: this.despedida.contrato_jazigo,
              dataCreate: this.despedida.dataCreate,
              data_update: this.despedida.data_update,
              user_create: this.despedida.user_create,
              user_update: this.despedida.user_update,
              status_memoria: this.despedida.status_memoria,
              tipo: this.despedida.tipo,
              com_moderacao: this.despedida.com_moderacao,
              transmissao: this.despedida.transmissao,
              codigo_transmissao: this.despedida.codigo_transmissao,
              obituario: this.despedida.obituario,
              publicacao: this.despedida.publicacao,
            },
            {
              headers: authHeader(),
            }
          );
        }

        this.imagem_falecido_novo = null;
        this.imagem_falecido_file = null;

        toast.success("Atualização finalizada com sucesso!");
        this.$router.push("/admin/despedidas");
        if (!response) {
          console.log(response);
        }
      } catch (error) {
        console.error("Erro ao cadastrar despedida:", error);
        throw error;
      }
      this.loadingDespedida = false;
    },

    // Função para converter o arquivo para Base64
    convertToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file); // Converte o arquivo para Base64
      });
    },
  },
};
</script>

<style scoped>
.v-main {
  background-color: #f5f5f5;
}
.container {
  min-height: 78vh !important;
  padding-top: 2rem;
}

.section-header {
  margin-bottom: 24px;
}

.section-title {
  color: #343f53;
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 8px;
}

.user {
  width: 160px;
  height: 160px;
  border-radius: 50%;
  border: 3px solid #ccc;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}
.profile-img {
  height: 100%;
  width: 100%;
  border-radius: 50%;
}
.icon {
  position: absolute;
  top: 22px;
  right: 16px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 100%;
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
}
.icon {
  transition: background 0.3s ease;
}
.icon:hover {
  background: rgba(0, 0, 0, 0.7);
}
</style>
